// extracted by mini-css-extract-plugin
module.exports = {"StyledContentTabs":"hshdY","StyledContentTabs_Tabs":"jGkr4","StyledContentTabs_Button":"gIyEO","StyledContentTabs_Button__active":"MlwrD"};